import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

// Utility function to get the correct redirect URL based on environment
export const getRedirectURL = () => {
    // In the browser: come back to the site the person is on (falashop.com, a Vercel
    // preview, or localhost on any port). Before, every preview sent Google sign-in and
    // email links to falashop.com (the live site). Supabase only accepts return
    // addresses listed in Authentication > URL Configuration > Redirect URLs; any other
    // falls back to the Site URL (falashop.com), i.e. what happened before.
    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/`;
    }

    // Check if we're in development mode
    const isDev = import.meta.env.DEV;
    
    // In development, always use localhost
    if (isDev) {
        return 'http://localhost:5173/';
    }
    
    // In production, use the configured site URL or Vercel URL
    let url = import.meta.env.VITE_SITE_URL ?? // Set this to your site URL in production env.
        import.meta.env.VITE_VERCEL_URL ?? // Automatically set by Vercel.
        'https://falashop.com'; // Fallback to your Vercel app URL
    
    // Make sure to include `https://` when not localhost
    url = url.startsWith('http') ? url : `https://${url}`;
    
    // Make sure to include a trailing `/`
    url = url.endsWith('/') ? url : `${url}/`;
    
    return url;
}

export const getAuthRedirectURL = (path: string) => {
    const normalizedPath = path.replace(/^\//, '')
    return `${getRedirectURL()}${normalizedPath}`
}

const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        detectSessionInUrl: true,
        persistSession: true,
        autoRefreshToken: true,
    },
})

export default supabase
